import { render, staticRenderFns } from "./VideocallReportTable.vue?vue&type=template&id=257e4770"
import script from "./VideocallReportTable.vue?vue&type=script&lang=js"
export * from "./VideocallReportTable.vue?vue&type=script&lang=js"
import style0 from "./VideocallReportTable.vue?vue&type=style&index=0&id=257e4770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports